import { reactive } from 'vue';
import makeStoreDebugAccessible from '@/core/store/store-debug';
import { ClientMessage, ClientMessageType } from '@/b2b/shared/api/server-apis';
import logging from '@/core/logging.service';

export interface ClientMessageEx extends ClientMessage {
    id: string;
}

interface IMessagesState {
    apiMessages: ClientMessageEx[];
}

class MessagesStore {
    private state: IMessagesState = reactive({
        apiMessages: [],
    });

    public constructor() {
        makeStoreDebugAccessible('messagesStore', this.state);
    }

    public get apiMessages(): ClientMessageEx[] {
        return this.state.apiMessages;
    }

    public addApiMessages(newMessages: ClientMessage[]): void {
        const uniqueNewMsgs = newMessages.filter(
            m => !this.state.apiMessages.find(am => am.message === m.message && am.messageType === m.messageType),
        );
        this.state.apiMessages = this.state.apiMessages.concat(
            uniqueNewMsgs.map((m, ix) => {
                return {
                    ...m,
                    id: new Date().valueOf() + ix.toString(),
                };
            }),
        );
    }

    public clearApiMessage(id: string): void {
        this.state.apiMessages = this.state.apiMessages.filter(m => m.id !== id);
    }

    public logCustomApiMessages(messages: ClientMessage[]): void {
        const logWithSeverity = {
            [ClientMessageType.Info]: logging.info.bind(logging),
            [ClientMessageType.Warning]: logging.warn.bind(logging),
            [ClientMessageType.Error]: logging.error.bind(logging),
        };

        messages.filter(message => !!message.message).forEach(message => {
            logWithSeverity[message.messageType](message.message);
        });
    }
}

export default new MessagesStore();
